import { makeStyles, Paper, Theme, createStyles } from '@material-ui/core';
import { Helmet } from 'react-helmet';
import Header from '../../components/Header/Header';
import { APP_TITLE } from '../../utils/constants';
import { GetString } from '../../components/StringResourceManager';
import ProductsContainer from '../../components/ProductsManagement/ProductsContainer';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-start',
      '& > *': {
        margin: theme.spacing(2),
      },
    },
    paperGrid: {
      marginTop: theme.spacing(7),
      display: 'flex',
      flexDirection: 'column',
    },
  }),
);

export default function ProductsImportMenu() {
  const classes = useStyles();

  return (
    <>
      <Helmet>
        <title>
          {GetString('PAGE_TITLE_PRODUCTS_IMPORT')} | {APP_TITLE}
        </title>
      </Helmet>
      <Header
        open={true}
        pageDisplayed={GetString('PAGE_TITLE_PRODUCTS_IMPORT')}
      />
      <Paper className={classes.paperGrid}>
        <ProductsContainer />
      </Paper>
    </>
  );
}
